export enum SlicesIdentity {
  CTA_BUTTON = 'cta_button',
  FRAMED_TEXT = 'framed_text',
  ICON_LINKS = 'icon_links',
  INTRO = 'intro',
  TEXT = 'text',
}

export enum CustomTypes {
  HEADER = 'header',
  LANDING = 'landing',
  FOOTER = 'footer',
}

export const DEFAULT_HEADER_UID = 'forge_trust_header';
export const DEFAULT_FOOTER_UID = 'footer';
